import { array, boolean, object, string } from "yup";

export const acquirerSchema = object({
    name: string().required("Nome é obrigatório"),
    description: string().required("Descrição é obrigatória"),
    active: boolean().default(true),
    type: string().required("Tipo é obrigatório"),
    acquirer_meta_data: array().of(
        object({
            key: string().required("Chave é obrigatória"),
            value: string().required("Valor é obrigatório"),
        })
    ),
});
